import { useState, useCallback } from 'react';

interface UseToastReturn {
  message: string | null;
  showToast: (msg: string, duration?: number) => void;
  dismissToast: () => void;
}

export function useToast(): UseToastReturn {
  const [message, setMessage] = useState<string | null>(null);
  const [, setQueue] = useState<Array<{ message: string; duration?: number }>>([]);

  const dismissToast = useCallback(() => {
    setMessage(null);

    setQueue((prevQueue) => {
      const [next, ...rest] = prevQueue;
      if (next) {
        setTimeout(() => {
          setMessage(next.message);
        }, 100);
      }
      return rest;
    });
  }, []);

  const showToast = useCallback(
    (msg: string, duration?: number) => {
      if (message === null) {
        setMessage(msg);
      } else {
        setQueue((prevQueue) => [...prevQueue, { message: msg, duration }]);
      }
    },
    [message],
  );

  return {
    message,
    showToast,
    dismissToast,
  };
}
